import React from 'react';
import { useRsvp } from '../context/RsvpContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowRightFromBracket, FaHouse } from 'react-icons/fa6';
import {routes} from "../routes";

const LogoutButton: React.FC = () => {
    const { setRsvp } = useRsvp();
    const navigate = useNavigate();
    const location = useLocation();

    const handleHome = () => {
        console.log('handleHome clicked, current location:', location.pathname);
        console.log('Navigating to:', routes.Home);
        navigate(routes.Home, { replace: true });
        console.log('Navigate called');
    };

    const handleLogout = () => {
        setRsvp(null);
        sessionStorage.setItem('rsvp_code', '');
        navigate(routes.CodeGate, { replace: true });
    };

    return (
        <div>
            <button
                onClick={handleHome}
                className="absolute top-4 left-4 z-50 size-10 rounded-full hover:cursor-pointer"
                aria-label="Home"
            >
                {FaHouse({size: 24, color: 'white'})}
            </button>
            <button
                onClick={handleLogout}
                className="absolute top-4 right-4 z-50 size-10 rounded-full hover:cursor-pointer"
                aria-label="Logout"
            >
                {FaArrowRightFromBracket({size: 24, color: 'white'})}
            </button>
        </div>

    );
};

export default LogoutButton;